import React, { useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useAppSelector } from '@/hooks/redux';
import { theme as baseTheme } from '@/styles/theme';

interface DynamicThemeProviderProps {
  children: React.ReactNode;
}

const DynamicThemeProvider: React.FC<DynamicThemeProviderProps> = ({ children }) => {
  const currentTheme = useAppSelector((state) => state.ui.theme);

  const dynamicTheme = useMemo(() => {
    const isDark = currentTheme === 'dark';
    
    return {
      ...baseTheme,
      colors: isDark ? baseTheme.darkColors : baseTheme.colors,
      isDark,
    };
  }, [currentTheme]);

  // 更新CSS变量以支持原生CSS
  React.useEffect(() => {
    const root = document.documentElement;
    const colors = dynamicTheme.colors;
    
    // 设置CSS变量
    root.style.setProperty('--color-primary', colors.primary);
    root.style.setProperty('--color-background-primary', colors.background.primary);
    root.style.setProperty('--color-background-secondary', colors.background.secondary);
    root.style.setProperty('--color-text-primary', colors.text.primary);
    root.style.setProperty('--color-text-secondary', colors.text.secondary);
    
    // 更新body背景色
    document.body.style.backgroundColor = colors.background.primary;
    document.body.style.color = colors.text.primary;
    
    // 更新meta theme-color
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', colors.background.primary);
    }
  }, [dynamicTheme]);

  return (
    <StyledThemeProvider theme={dynamicTheme}>
      {children}
    </StyledThemeProvider>
  );
};

export default DynamicThemeProvider;